define(
    'viewmodels/secured/libraries/libraries',[
        "viewmodels/ViewModelNotification",
        "providers/dataprovider",
        "plugins/router",
        "i19n!i19n/strings",
        "viewmodels/secured/libraries/dashboard",
        "viewmodels/secured/libraries/create",
        "viewmodels/secured/libraries/empty",
        "viewmodels/secured/libraries/delete",
        "viewmodels/secured/libraries/settings",
        "viewmodels/secured/libraries/columns",
        "viewmodels/secured/libraries/fields",
        "viewmodels/secured/libraries/access"
    ],
    function (ViewModelNotification, dataProvider, router, i19n, dashboardModel, createModel, emptyModel, deleteModel, settingsModel, columnsModel, fieldsModel, accessModel) {
        var comboBox = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            lists: ko.observable([]),
            selectedLibrary: ko.observable(),
            navMenu: { navs: ko.observableArray([]) },
            navAction: ko.observable(),
            isLibraryEmpty: ko.observable(false),
            isAdmin: false,
            reloadOn: function () {}
        });

        vm.activate = function (id) {
            vm.navReset();

            if (!id)
                sessionStorage.setItem("view-library-nav-id", "dashboard");
            else
                sessionStorage.setItem("view-library-nav-id", id);

            vm.notifications([]);

            vm.isAdmin = (vm.session.role == 3 || vm.session.role == 4 ? true : false);

            if (vm.isAdmin) {
                vm.navMenu.navs([
                    { id: "create", text: i19n.to.create, isSelected: ko.observable(false), isDisabled: ko.observable(false) },
                    { id: "dashboard", text: i19n.to.dashboard, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "settings", text: i19n.to.settings, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "columns", text: i19n.to.columns, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "fields", text: i19n.to.fields, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "access", text: i19n.to.accesscontrol, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "empty", text: i19n.to.emptylibrary, isSelected: ko.observable(false), isDisabled: ko.observable(true) },
                    { id: "delete", text: i19n.to.deletelibrary, isSelected: ko.observable(false), isDisabled: ko.observable(true) }
                ]);
            }

            if (id == "create") {
                vm.comboClick(null);

                sessionStorage.setItem("view-library-id", null);
                //sessionStorage.setItem("view-library-nav-id", null);
                sessionStorage.setItem("navto", "explorer");

                vm.navCreateMode();

                vm.navAction(getViewModel("create"));

                $.map(vm.navMenu.navs(), function (itm) {
                    itm.isSelected(itm.id == "create");
                });
            } else {
                if (comboBox) {
                    vm.comboClick(comboBox.value());
                }
            }
        };
        vm.attached = function() {
            comboBox = $("#libraries").kendoDropDownList({
                dataTextField: "name",
                dataValueField: "libraryId",
                optionLabel: i19n.to.selectalibrary,
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            dataProvider.libraries
                            .getLibrariesLookup()
                            .done(function (data) {
                                data = data || [];                                    
                                data = _.sortBy(data, function (itm) { return itm.name.toLowerCase(); });
                                //data = _.where(data, {name : "not-found"});                                    

                                vm.isLibraryEmpty(data.length == 0);

                                vm.lists(data);

                                callbacks.success(vm.lists());

                                vm.reloadOn();                                                                
                                
                                if (!comboBox.__donotloadcache) {
                                    if (data.length > 0) {
                                        var libraryId = sessionStorage.getItem("view-library-id");
                                        if (!(libraryId == 'null' || libraryId == null || !libraryId)) {
                                            vm.selectedLibrary(libraryId);
                                            vm.comboClick(libraryId);
                                            vm.navEditMode();
                                        }
                                    }
                                }
                            });
                        },
                    }
                },
                change: onChange
            }).data("kendoDropDownList");
        };
        vm.navClick = function ($data) {
            if ($data.isDisabled())
                return;

            sessionStorage.setItem("view-library-nav-id", $data.id);

            vm.clearNotifications();

            if ($data.id == "create") {
                comboBox.select(0);
                vm.navCreateMode();
            }
            
            var library = comboBox.dataItem();
            if ($data.id == "dashboard" && !(!library || !library.libraryId)) {
                vm.navAction(getViewModel('dashboard', library.libraryId));
            } else {
                vm.navAction(getViewModel($data.id));
            }

            $.map(vm.navMenu.navs(), function (itm) {
                itm.isSelected(itm.id == $data.id);
            });
        };
        vm.navReset = function () {
            vm.navAction({});

            $.map(vm.navMenu.navs(), function (itm) {
                itm.isSelected(false);
            });

            vm.navCreateMode();
        };
        vm.navCreateMode = function () {
            var self = this;

            if (!self.isAdmin)
                return;

            vm.isLibraryEmpty(false);

            _.find(vm.navMenu.navs(), function (data) { return data.id == "dashboard"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "settings"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "columns"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "fields"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "access"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "empty"; }).isDisabled(true);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "delete"; }).isDisabled(true);
        };
        vm.navEditMode = function () {
            var self = this;

            if (!self.isAdmin)
                return;

            _.find(vm.navMenu.navs(), function (data) { return data.id == "dashboard"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "settings"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "columns"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "fields"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "access"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "empty"; }).isDisabled(false);
            _.find(vm.navMenu.navs(), function (data) { return data.id == "delete"; }).isDisabled(false);
        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };
        vm.reload = function (selectedValue, donotloadcache) {
            if (comboBox) {
                comboBox.__donotloadcache = !(!donotloadcache);

                comboBox.dataSource.read();

                if (comboBox.__donotloadcache) {
                    comboBox.dataItem().set('name', donotloadcache);

                    return;
                }

                vm.reloadOn = function () {
                    if (comboBox) {
                        if (selectedValue !== undefined) {
                            comboBox.value(selectedValue);
                            vm.selectedLibrary(comboBox.dataItem().libraryId);

                            onChange();
                        }
                    }
                };
            }
        };
        vm.comboClick = function (id) {
            if (comboBox) {
                if (id === undefined) {
                    vm.navReset();
                    comboBox.select(0);
                } else {
                    comboBox.value(id);
                    onChange();
                }
            }
        };

        return vm;

        function onChange() {
            vm.navReset();

            var library = comboBox.dataItem();

            sessionStorage.removeItem("view-library-id");
            sessionStorage.setItem("view-library-id", library.libraryId);

            if (!library || !library.libraryId) {
            } else {
                vm.navEditMode();
                if (!(!sessionStorage.getItem("view-library-nav-id")) && sessionStorage.getItem("view-library-nav-id") == "create") {
                    vm.navClick({ id: "dashboard", isDisabled: function () { return false; } });
                } else {
                    vm.navClick({ id: sessionStorage.getItem("view-library-nav-id"), isDisabled: function () { return false; } });
                }
            }
        }
        function getViewModel(type, data) {
            var model = {};

            if (type == 'dashboard') model = dashboardModel;
            if (type == 'create') model = createModel;            
            if (type == 'settings') model = settingsModel;
            if (type == 'columns') model = columnsModel;
            if (type == 'fields') model = fieldsModel;
            if (type == 'access') model = accessModel;
            if (type == 'empty') model = emptyModel;
            if (type == 'delete') model = deleteModel;

            if (type == 'delete') {
                model.name = comboBox.dataItem().name;
            }
            
            if (type == 'empty') {
                model.name = comboBox.dataItem().name;
            }

            if (type == 'dashboard')
                model.id = data;
            else
                model.id = vm.selectedLibrary();

            model.notify = vm.notify;
            model.reload = vm.reload;
            model.comboClick = vm.comboClick;
            
            return model;
        }
    }
);
